import { render, staticRenderFns } from "./loading-product.vue?vue&type=template&id=19218d75"
import script from "./loading-product.vue?vue&type=script&lang=js"
export * from "./loading-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports